import { Link } from "react-router-dom";
import { heroImages, siteConfig } from "@/mocks/site";

export default function Hero() {
  return (
    <section className="relative overflow-hidden bg-background-950">
      <img
        src={heroImages.heroBanner}
        alt="宅宅资源库合集索引归档整理背景图"
        className="absolute inset-0 h-full w-full object-cover object-top opacity-45"
      />
      <div className="absolute inset-0 bg-gradient-to-b from-background-950/60 via-background-950/40 to-background-950"></div>
      <div className="container-site relative w-full py-20 md:py-28">
        <div className="max-w-2xl">
          <p className="inline-flex items-center gap-2 rounded-full bg-background-50/10 px-4 py-1.5 text-xs font-medium text-background-100 ring-1 ring-background-50/20 md:text-sm">
            <i className="ri-archive-2-line text-accent-400"></i>
            {siteConfig.slogan}
          </p>
          <h1 className="mt-6 font-heading text-3xl font-black leading-tight text-background-50 md:text-5xl md:leading-tight">
            把零散的资源，
            <br />
            整理成随手可查的目录
          </h1>
          <p className="mt-5 max-w-xl text-sm leading-7 text-background-200 md:text-base">
            以合集、索引、归档三种形式整理各类资源，整理贴持续补全并更新目录。想按系列或作者批量收藏，直接查归档列表即可，省去零散收藏的麻烦，找资源更有条理。
          </p>
          <div className="mt-8 flex flex-col gap-3 sm:flex-row">
            <Link
              to="/collections"
              className="btn-primary bg-accent-500 text-background-50 hover:bg-accent-600"
            >
              <i className="ri-stack-line mr-2"></i>
              浏览合集
            </Link>
            <Link
              to="/archive"
              className="inline-flex items-center justify-center whitespace-nowrap rounded-md border border-background-50/30 bg-transparent px-5 py-2.5 text-sm font-medium text-background-50 transition-colors hover:bg-background-50/10"
            >
              <i className="ri-archive-line mr-2"></i>
              查看归档索引
            </Link>
          </div>
        </div>
      </div>
    </section>
  );
}